import React, { Component } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

// Components
import DataSlot from 'components/atoms/DataSlot';
import { TextField } from 'components/api';

import './MileageBuilder.scss';

const ns = 'mileage-builder';

class MileageBuilder extends Component {
  constructor(props) {
    super(props);
    this.onMileageChange = this.onMileageChange.bind(this);
    this.handleMileageSubmit = this.handleMileageSubmit.bind(this);
  }

  handleMileageSubmit = e => {
    e.preventDefault();
    const { model, engineSize, hasIDK, selectMileage, mileage } = this.props;
    if ((model && hasIDK) || engineSize) {
      selectMileage(mileage);
    }
  };

  onMileageChange = ({ target: { value } }) => {
    const { setMileage } = this.props;
    setMileage(value.replace(/[^0-9]/g, ''));
  };

  render() {
    const {
      className,
      selectMileage,
      mileage,
      mileageUnit,
      gtmUserEvent,
      intl,
      isQuoteAppt
    } = this.props;
    const classProps = cn(ns, className);
    const mileagesArray = [];
    let i;
    for (i = 0; i < 30; i += 1) {
      mileagesArray.push({
        value: (20 + i * 5) * 1000,
        display: `${20 + i * 5}K`
      });
    }
    return (
      <div className={classProps}>
        <div className={`d-sm-none ${ns}__mileage-title`}>
          {intl.formatMessage({ id: 'c8.vehicle.page.mileage' })}
        </div>
        {!isQuoteAppt && (
          <div className={`${ns}__mileage-subtitle py-0`}>
            {intl.formatMessage({
              id: 'c8.vehicle.page.take.your.best.guess.rough.estimate.is.fine'
            })}
          </div>
        )}
        <form onSubmit={this.handleMileageSubmit}>
          <div className={`${ns}__form-fields`}>
            <TextField
              className={`${ns}__mileage-input`}
              name="mileage_input"
              placeholder={
                !isQuoteAppt
                  ? intl.formatMessage({
                      id:
                        mileageUnit === 'km'
                          ? 'c8.vehicle.page.enter.kms'
                          : 'c8.vehicle.page.enter.miles'
                    })
                  : ''
              }
              maxLength="7"
              value={(mileage && mileage.toLocaleString()) || ''}
              onChange={this.onMileageChange}
              type="tel"
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.enter.estimate.mileage',
                defaultMessage: 'Enter estimate mileage'
              })}
              disabled={isQuoteAppt}
            />
          </div>
        </form>
        <div className={`d-sm-none ${ns}__selector-group`}>
          {mileagesArray.map(({ display, value }) => (
            <DataSlot
              key={value}
              bsStyle="primary"
              onClick={() => {
                selectMileage(value, true);
                gtmUserEvent(
                  'Mileage Button',
                  'Clicked',
                  `${display} selected`,
                  'GTM_CURRENT_PAGE > Services',
                  `${value}`
                );
              }}
              value={display}
            />
          ))}
        </div>
      </div>
    );
  }
}

MileageBuilder.propTypes = {
  className: PropTypes.string,
  engineSize: PropTypes.string,
  gtmUserEvent: PropTypes.func,
  hasIDK: PropTypes.bool,
  intl: PropTypes.object,
  mileage: PropTypes.number,
  mileageUnit: PropTypes.string,
  model: PropTypes.string,
  onClick: PropTypes.func,
  selectMileage: PropTypes.func.isRequired,
  setMileage: PropTypes.func.isRequired,
  value: PropTypes.string,
  isQuoteAppt: PropTypes.bool.isRequired
};

MileageBuilder.defaultProps = {
  onClick: () => {}
};

export default MileageBuilder;



// WEBPACK FOOTER //
// ./src/components/molecules/MileageBuilder/MileageBuilder.js